import { ISearchVerifResponse } from '@/lib/interface';
import { VerificationTypesEnum } from '@/lib/enum';
import { useQuery } from '@tanstack/react-query';
import { handleApiResponse } from '@/functions';
import { apiClient } from '@/components/api';
import routes from '@/lib/routes';
import dayjs from 'dayjs';

type TParams = {
  type?: VerificationTypesEnum;
  date: string | Date;
  sortType?: string;
  sortBy?: string;
  page: number;
};
type TResponseData = ISearchVerifResponse;

export const useRequestGetVerificationsCompleted = (params?: TParams, run = true) => {

  const { isFetching, data, error, dataUpdatedAt, refetch } = useQuery({
    queryKey: [routes.api.verifications.completed, params, run],
    queryFn: ({ queryKey: [_url, _params, _run] }) =>
      !_run
        ? Promise.resolve(null)
        : fetchQuery(_url as string, _params as TParams)
  });

  const verifications = (data?.data ?? []);

  const fetchQuery = (url: string, params: TParams) =>
    apiClient
      .get<TResponseData>(url, params)
      .then(handleApiResponse)
      .then(
        data =>
          data
            ? ({
              ...data,
              data: (
                data.data
                  ? [...data.data]
                    .map(
                      l => ({
                        ...l,
                        createdAt: dayjs(l.createdAt).toDate()
                      })
                    )
                  : data.data
              )
            })
            : data
      );

  const fetchData = (params: TParams) =>
    fetchQuery(routes.api.verifications.completed, params);

  const refresh = () =>
    refetch({ cancelRefetch: true });

  return ({
    data: data as TResponseData,
    isLoading: isFetching,
    dataUpdatedAt,
    verifications,
    fetchData,
    refresh,
    error
  });

};
